import { render, staticRenderFns } from "./GoeOccupationalFactors.vue?vue&type=template&id=0642fb07&scoped=true"
import script from "./GoeOccupationalFactors.vue?vue&type=script&lang=js"
export * from "./GoeOccupationalFactors.vue?vue&type=script&lang=js"
import style0 from "./GoeOccupationalFactors.vue?vue&type=style&index=0&id=0642fb07&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642fb07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0642fb07')) {
      api.createRecord('0642fb07', component.options)
    } else {
      api.reload('0642fb07', component.options)
    }
    module.hot.accept("./GoeOccupationalFactors.vue?vue&type=template&id=0642fb07&scoped=true", function () {
      api.rerender('0642fb07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/seven/components/GoeOccupationalFactors.vue"
export default component.exports